module.exports = __webpack_public_path__ + "static/media/LU.fadfd370.svg";